import {
	PEOPLE_OPEN_SHIFT_APPLICATION_STATUS,
	PEOPLE_TIMESHEET_STATUS,
} from '../../../common/constants';
import {
	formatShiftRange,
	getOpenShiftApplicationStatusIntent,
	getUnavailabilityStatusIntent,
} from '../../../common/utils/people/roster';

export const ROSTER_DATE_FORMAT = 'ddd D MMM';
// Shared by My roster and the sub-pages so their queries share the same cached results.
export const UPCOMING_OPEN_SHIFT_DAYS = 28;
export const TIMESHEET_PAGE_SIZE = 20;

export const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

// A declined application can be made again.
export const canApplyForOpenShift = openShift => !openShift.myApplication ||
	Number(openShift.myApplication.status) === PEOPLE_OPEN_SHIFT_APPLICATION_STATUS.DECLINED;

// The shared helpers return Blueprint intents; StatusBadge calls 'none' neutral.
const toBadgeTone = intent => (intent === 'none' ? 'neutral' : intent);

export const getUnavailabilityBadgeTone = status => toBadgeTone(getUnavailabilityStatusIntent(status));

export const getApplicationBadgeTone = status => toBadgeTone(getOpenShiftApplicationStatusIntent(status));

export const getTimesheetBadgeTone = (status) => {
	switch (Number(status)) {
		case PEOPLE_TIMESHEET_STATUS.APPROVED:
			return 'success';
		case PEOPLE_TIMESHEET_STATUS.DISCARDED:
			return 'danger';
		default:
			return 'neutral';
	}
};

// "Driver · 7am – 3pm" for shift and open shift rows.
export const formatShiftSummary = shift => [
	shift.areaLabel,
	formatShiftRange(shift.startMinutes, shift.endMinutes),
].filter(Boolean).join(' · ');
